import React from 'react'
import ReactDOM from 'react-dom'
import {
  BrowserRouter as Router,
  Route,
  Switch,
  Redirect,
} from 'react-router-dom'

import './style.css'
import GDPRLegal from './views/gdpr-legal'
import WebsiteCreationMainService from './views/website-creation-main-service'
import Pricing from './views/pricing'
import ContactBookACall from './views/contact-book-a-call'
import Home from './views/home'
import ProcessPage from './views/process-page'
import About from './views/about'
import NotFound from './views/not-found'

const App = () => {
  return (
    <Router>
      <Switch>
        <Route component={GDPRLegal} exact path="/gdpr-legal" />
        <Route
          component={WebsiteCreationMainService}
          exact
          path="/website-creation-main-service"
        />
        <Route component={Pricing} exact path="/pricing" />
        <Route component={ContactBookACall} exact path="/contact-book-a-call" />
        <Route component={Home} exact path="/" />
        <Route component={ProcessPage} exact path="/process-page" />
        <Route component={About} exact path="/about" />
        <Route component={NotFound} path="**" />
        <Redirect to="**" />
      </Switch>
    </Router>
  )
}

ReactDOM.render(<App />, document.getElementById('app'))
